import { useState } from 'react'
import { Link as RouterLink } from 'react-router'

import CardActionArea from '@mui/material/CardActionArea'
import Snackbar from '@mui/material/Snackbar'
import Typography from '@components/_mui/Typography'

import usePubNub, { Channels } from '@shared/hooks/src/usePubNub'
import { useMe } from '@shared/providers/src/MeProvider'
import { UserRole } from '@shared/utils'

import { styles, Title } from '../Notifications.utils'

export default function AdminNotifications() {
  const me = useMe()
  const [open, setOpen] = useState(false)
  const [data, setData] = useState(undefined)

  const handleClose = () => setOpen(false)

  usePubNub(
    'platform_admins',
    ({ action, attributes }) => {
      if (action === Channels.Notify) {
        setData(attributes)
        setOpen(true)
      }
    },
    { enabled: me.role === UserRole.Admin }
  )

  return (
    <Snackbar
      open={open}
      onClose={(event, reason) => {
        if (reason === 'escapeKeyDown') handleClose()
      }}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <CardActionArea component={RouterLink} to={data?.path} target="_blank" sx={[styles.container, styles.warning]}>
        <Title label="Admin Alert" color="warning" onClose={handleClose} />
        <Typography>{data?.message}</Typography>
      </CardActionArea>
    </Snackbar>
  )
}
